
  import { Component, Vue, VModel } from "vue-property-decorator";

  type ReviewsProps = WebProps["reviews"];

  @Component({ name: "Reviews" })
  export default class Reviews extends Vue {
    @VModel() props!: ReviewsProps; // TODO: Map to inputs
  }
